<div class="table-content-component-panel-monitoreo" style="position: relative;">

  <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" name="loadingGeopointsSpinner" size = "medium" color = "#fff" type = "ball-pulse" [fullScreen] = "false"><p style="color: white" > {{'GEOPOINTS.MESSAGE.LOADING' | translate}} </p></ngx-spinner>

  <div class="card-body p-fluid bg-gl-blue-dark" id="rowBusqueda">
    <div class="d-flex" style="height: 38px;">
      <div class="d-flex flex-grow-1">
        <span class="p-input-icon-right flex-grow-1 me-2">
          <i class="fa fa-search" aria-hidden="true"></i>
          <input type="text" (keyup)="onBusqueda($event)" [(ngModel)]="NomBusqueda"  class="form-control" placeholder="Buscar por nombre" [placeholder]="'GEOPOINTS.ACTION.SEARCH_BY_NAME' | translate">
        </span>
      </div>
      <ng-container *ngIf="geopointsService.config.createBtn">
        <ng-container *appHasPermission="'geopoints_create'">
          <button type="button" *ngIf="geopointsService.showBtnAdd" class="btn-gl-blue btn-dark-hover btn-circle flex-none" (click)="clickAgregarGeopunto()" title="Crear geocerca">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <div class="flex-none d-flex justify-content-center gap-5 resumen-tabla-geo">
    <div class="d-flex align-items-center" *ngIf="geopointsService.config.showGeopointsVisible">
      <span>{{'GEOPOINTS.MESSAGE.VISIBLE_GEOPOINTS' | translate}}</span>
      <div class="p-1 geo-counter counter-visible">{{ geopointsService.geopointCounters.visible }}</div>
    </div>
    <div class="d-flex align-items-center"  *ngIf="geopointsService.config.showGeopointsHidden">
      <span>{{'GEOPOINTS.MESSAGE.HIDDEN_GEOPOINTS' | translate}}</span>
      <div class="p-1 geo-counter counter-hidden">{{ geopointsService.geopointCounters.hidden }}</div>
    </div>
  </div>


  <p-table
    #geoTable
    [value]="geopointsService.tblDataGeoFiltered"
    styleClass="p-datatable-sm"
    [scrollable]="true"
    scrollHeight="calc(100vh - calc(calc(calc(var(--navbar-height) + var(--row-busqueda-height)) + calc(var(--pm-vehiculos-header-height) + var(--treetable-header-height)))))"
  >
    <!-- Encabezados -->
    <ng-template pTemplate="header">
      <tr>
        <th *ngIf="geopointsService.config.tableColumns.showPoint" style="width: 20%;" class="text-center">
          <p-inputSwitch
            [(ngModel)]="geopointsService.eyeInputSwitch"
            (click)="onClickEye()"
            [disabled]="geopointsService.tblDataGeo.length == 0"
            ngDefaultControl
          ></p-inputSwitch>
        </th>

        <th *ngIf="geopointsService.config.tableColumns.name" colspan="2" style="width: 50%;" class="text-start">
          {{ 'COMMON.GEOPOINT' | translate }}
        </th>

        <th *ngIf="geopointsService.config.tableColumns.showPointName" style="width: 15%;" class="text-center">
          <i class="fa fa-id-card fa-lg mini-eye-container" (click)="onClickTagNamesEye()">
            <div>
              <i *ngIf="geopointsService.tagNamesEyeState" class="fas fa-eye mini-eye"></i>
              <i *ngIf="!geopointsService.tagNamesEyeState" class="far fa-eye-slash mini-eye"></i>
            </div>
          </i>
        </th>

        <th *ngIf="geopointsService.showBtnEdit && geopointsService.config.tableColumns.edit" style="width: 15%;" class="text-center">
          <i class="fa fa-pencil fa-lg"></i>
        </th>
      </tr>
    </ng-template>

    <!-- Filas -->
    <ng-template pTemplate="body" let-geo let-i="rowIndex">
      <tr>
        <td *ngIf="geopointsService.config.tableColumns.showPoint" style="width: 20%;" class="text-center">
          <button class="btn btn-xs btn-link p-n eye-column" (click)="clickShow(geo.trama.geopunto_id)">
            <i
              [ngClass]="{
                'fas fa-eye': geo.trama.geopunto_visible === 'true',
                'far fa-eye-slash': geo.trama.geopunto_visible === 'false'
              }"
            ></i>
          </button>
        </td>
        <td *ngIf="geopointsService.config.tableColumns.name" style="width: 50%;">
          <div class="flex flex-row align-items-center gap-2" style="display: flex;">
            <i
              [ngStyle]="{ color: geo.trama.geopunto_color }"
              (click)="clickLocate(geo.trama.geopunto_id)"
              class="fa fa-map-marker geopoint-marker"
              style="font-size: 1.6rem; cursor: pointer;"
            ></i>
            <span>{{ geo.trama.geopunto_name }}</span>
          </div>
        </td>


        <td *ngIf="geopointsService.config.tableColumns.showPointName" style="width: 15%;" class="text-center">
          <p-checkbox
            [(ngModel)]="geo.trama.geopunto_nombre_visible_bol"
            (onChange)="clickShowNameGeocerca(geo.trama.geopunto_id)"
            [binary]="true"
          ></p-checkbox>
        </td>

        <ng-container *appHasPermission="['geopoints_update', 'geopoints_delete']">
          <td *ngIf="geopointsService.showBtnEdit && geopointsService.config.tableColumns.edit" style="width: 15%;" class="text-center">
            <div
              ngbDropdown
              container="body"
              class="d-flex justify-content-center align-items-center edit-column"
              [autoClose]="true"
              placement="right-top right-bottom left-top left-bottom"
            >
              <i class="fa fa-pencil" ngbDropdownToggle></i>
              <div ngbDropdownMenu class="gl-custom-dropdown geofences-table-dropdown">
                <div
                  *appHasPermission="'geopoints_update'"
                  ngbDropdownItem
                  (click)="clickConfigurarGeopunto(geo.trama.geopunto_id)"
                >
                  <i class="fa fa-pencil-square-o" aria-hidden="true"></i> Configurar
                </div>
                <div
                  *appHasPermission="'geopoints_delete'"
                  ngbDropdownItem
                  (click)="clickEliminarGeopunto($event, geo.trama.geopunto_id)"
                >
                  <i class="fa fa-trash-o" aria-hidden="true"></i> Eliminar
                </div>
              </div>
            </div>
          </td>
        </ng-container>
      </tr>
    </ng-template>

    <!-- Sin resultados -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center">Sin coincidencias</td>
      </tr>
    </ng-template>
  </p-table>


</div>
